import styles from "./SettingsNavigationSection.module.scss"
import { SettingsNavigationSectionProps } from "./SettingsNavigationSection.types"

export default function SettingsNavigationSection(props: SettingsNavigationSectionProps) {
    const { title, children } = props

    return (
        <nav className={styles.base}>
            <span className={styles.sectionHeader}>{title}</span>
            {children}
        </nav>
    )
}
